import api from './index';
import { setToken } from '../utils/authUtils';
import {
    ApiKeyCredentials,
    ApiKeyForm,
    ApiKeyInterface,
    ApiScopeInterface,
    ApiTokenInterface,
} from '../types/ApiKey.interface';

const BASE = '/keys';

export const getApiKeys = async (): Promise<Array<ApiKeyInterface>> => {
    return api.get(BASE, await setToken()).then((res) => res.data);
};

export const getApiPermissions = async (): Promise<ApiScopeInterface[]> => {
    return api.get<ApiScopeInterface[]>(`${BASE}/permissions`, await setToken()).then((res) => res.data);
};

export const createApiKey = async (data: ApiKeyForm): Promise<ApiKeyInterface> => {
    return api.post(`${BASE}`, data, await setToken()).then((res) => res.data);
};

export const updateApiKey = async ({ client_id, ...data }: ApiKeyForm): Promise<ApiKeyInterface> => {
    return api.patch(`${BASE}/${client_id}`, data, await setToken()).then((res) => res.data);
};

export const deleteApiKey = async (client_id: string): Promise<ApiKeyInterface> => {
    return api.delete(`${BASE}/${client_id}`, await setToken()).then((res) => res.data);
};

export const generateApiToken = async ({ client_id, client_secret }: ApiKeyCredentials): Promise<ApiTokenInterface> => {
    return api.post(`/token`, { client_id, client_secret }, await setToken()).then((res) => res.data);
};
